import { api } from "./api";

const actions = {
	/**
	 * Create a new notification
	 * @param {object} data - Notification data
	 * @param {function} onSuccess - Callback on success
	 * @param {function} onFailure - Callback on failure
	 * @returns {function} Thunk action
	 *
	 * Data format:
	 * {
	 *   type: string (required),
	 *   target: string (required),
	 *   action: string (required),
	 *   payload: object (required),
	 *   severity: 'info' | 'warning' | 'error' | 'success' (optional, default: 'info'),
	 *   read: boolean (optional, default: false),
	 *   message: object { title: string, content: string } (required)
	 * }
	 */
	createNotification: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/notifications`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Get all notifications
	 * @param {function} onSuccess - Callback on success
	 * @param {function} onFailure - Callback on failure
	 * @returns {function} Thunk action
	 */
	getNotifications: (read = undefined, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					data: {
						read
					},
					url: `/api/v1/notifications`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Mark a notification as read
	 * @param {string} notificationID - ID of the notification to mark as read
	 * @param {function} onSuccess - Callback on success
	 * @param {function} onFailure - Callback on failure
	 * @returns {function} Thunk action
	 */
	markAsRead: (notificationID, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					data: {},
					url: `/api/v1/notifications/${notificationID}/read`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Mark all notifications as read
	 * @param {function} onSuccess - Callback on success
	 * @param {function} onFailure - Callback on failure
	 * @returns {function} Thunk action
	 */
	markAllAsRead: (onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					data: {},
					url: `/api/v1/notifications/read-all`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Delete a notification
	 * @param {string} notificationID - ID of the notification to delete
	 * @param {function} onSuccess - Callback on success
	 * @param {function} onFailure - Callback on failure
	 * @returns {function} Thunk action
	 */
	deleteNotification: (notificationID, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "DELETE",
					url: `/api/v1/notifications/${notificationID}`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Get count of unread notifications
	 * @param {function} onSuccess - Callback on success
	 * @param {function} onFailure - Callback on failure
	 * @returns {function} Thunk action
	 */
	countUnread: (onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/notifications/unread/count`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Get a notification by ID
	 * @param {string} notificationID - ID of the notification to retrieve
	 * @param {function} onSuccess - Callback on success
	 * @param {function} onFailure - Callback on failure
	 * @returns {function} Thunk action
	 */
	getNotificationById: (notificationID, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/notifications/${notificationID}`,
					onSuccess,
					onFailure
				})
			);
		};
	}
};

export default actions;
